import JitsiStreamBrightnessEffect from './JitsiStreamBrightnessEffect';
/**
 * Creates a new instance of the brightness stream effect.
 *
 * @returns {JitsiStreamBrightnessEffect}
 */
export function createBrightnessEffect() {
    if (!MediaStreamTrack.prototype.getSettings && !MediaStreamTrack.prototype.getConstraints) {
        throw new Error('JitsiStreamBrightnessEffect not supported!');
    }
    return new JitsiStreamBrightnessEffect();
}
